// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import type { ThemeMetadata } from './types';

// 5 hazır tema şablonu — admin editöründe tek tıkla seçilebilir.

export const ElpoDefault: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Elpo Default',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#ffffff',
    foreground: '#0a0a0a',
    card: '#ffffff',
    cardForeground: '#0a0a0a',
    popover: '#ffffff',
    popoverForeground: '#0a0a0a',
    primary: '#003b5c',
    primaryForeground: '#ffffff',
    secondary: '#f1f3f7',
    secondaryForeground: '#003b5c',
    muted: '#ececf0',
    mutedForeground: '#717182',
    accent: '#e9ebef',
    accentForeground: '#003b5c',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(0, 0, 0, 0.1)',
    input: 'transparent',
    inputBackground: '#f3f3f5',
    ring: '#a1a1aa',
    sidebar: '#003B5C',
    sidebarForeground: 'rgba(255,255,255,0.85)',
    sidebarPrimary: '#0091B3',
    sidebarAccent: 'rgba(255,255,255,0.14)',
    sidebarBorder: 'rgba(255,255,255,0.1)',
  },
  colorsDark: {
    background: '#0a0a0a',
    foreground: '#fafafa',
    card: '#0a0a0a',
    cardForeground: '#fafafa',
    popover: '#0a0a0a',
    popoverForeground: '#fafafa',
    primary: '#fafafa',
    primaryForeground: '#1a1a1a',
    secondary: '#262626',
    secondaryForeground: '#fafafa',
    muted: '#262626',
    mutedForeground: '#a1a1aa',
    accent: '#262626',
    accentForeground: '#fafafa',
    destructive: '#7f1d1d',
    destructiveForeground: '#fecaca',
    border: '#262626',
    input: '#262626',
    ring: '#525252',
    sidebar: '#1a1a1a',
    sidebarForeground: '#fafafa',
    sidebarPrimary: '#0091B3',
    sidebarAccent: '#262626',
    sidebarBorder: '#262626',
  },
};

// VARSAYILAN (kullanıcı kararı 2026-06-14): MENÜ teal, İÇERİK krem. Tema seçilmemişse bu gelir.
// İçerik sıcak krem zemin + okunaklı koyu metin; menü derin teal + açık teal aktif/ikon.
export const ElpoTealCream: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Teal & Krem',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f7f2e7',
    foreground: '#2d2a22',
    card: '#fffdf7',
    cardForeground: '#2d2a22',
    popover: '#fffdf7',
    popoverForeground: '#2d2a22',
    primary: '#0d9488',
    primaryForeground: '#ffffff',
    secondary: '#ede6d5',
    secondaryForeground: '#2d2a22',
    muted: '#ede6d5',
    mutedForeground: '#7a7264',
    accent: '#d9efe9',
    accentForeground: '#0d5249',
    destructive: '#dc2626',
    destructiveForeground: '#ffffff',
    border: 'rgba(70,60,35,0.13)',
    input: 'transparent',
    inputBackground: '#efe8d8',
    ring: '#0d9488',
    sidebar: '#0f4c46',
    sidebarForeground: 'rgba(255,255,255,0.86)',
    sidebarPrimary: '#5eead4',
    sidebarAccent: 'rgba(255,255,255,0.12)',
    sidebarBorder: 'rgba(255,255,255,0.10)',
  },
  colorsDark: {
    background: '#12110d',
    foreground: '#ece7da',
    card: '#1b1914',
    cardForeground: '#ece7da',
    popover: '#1b1914',
    popoverForeground: '#ece7da',
    primary: '#2dd4bf',
    primaryForeground: '#042f2e',
    secondary: '#231f17',
    secondaryForeground: '#ece7da',
    muted: '#231f17',
    mutedForeground: '#a39a86',
    accent: '#0c3b36',
    accentForeground: '#5eead4',
    destructive: '#f87171',
    destructiveForeground: '#1a0606',
    border: 'rgba(255,255,255,0.09)',
    input: 'transparent',
    inputBackground: '#231f17',
    ring: '#2dd4bf',
    sidebar: '#0a2f2b',
    sidebarForeground: 'rgba(255,255,255,0.86)',
    sidebarPrimary: '#5eead4',
    sidebarAccent: 'rgba(255,255,255,0.10)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

// ELPO KURUMSAL (kullanıcı kararı 2026-06-19): MENÜ derin lacivert, İÇERİK temiz açık, AKSAN turkuaz.
// Elpo marka renkleri (lacivert + turkuaz) — kurumsal ERP/fintech kimliği. Yeni VARSAYILAN tema.
export const ElpoNavyTurquoise: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Elpo Kurumsal',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f4f7fc',
    foreground: '#14213d',
    card: '#ffffff',
    cardForeground: '#14213d',
    popover: '#ffffff',
    popoverForeground: '#14213d',
    primary: '#003b5c',
    primaryForeground: '#ffffff',
    secondary: '#e8eef7',
    secondaryForeground: '#14213d',
    muted: '#e8eef7',
    mutedForeground: '#5b6b86',
    accent: '#d8eef5',
    accentForeground: '#00566b',
    destructive: '#dc2626',
    destructiveForeground: '#ffffff',
    border: 'rgba(20,33,61,0.12)',
    input: 'transparent',
    inputBackground: '#eaf0f8',
    ring: '#0091b3',
    sidebar: '#003b5c',
    sidebarForeground: 'rgba(255,255,255,0.86)',
    sidebarPrimary: '#4db8d1',
    sidebarAccent: 'rgba(255,255,255,0.10)',
    sidebarBorder: 'rgba(255,255,255,0.10)',
  },
  colorsDark: {
    background: '#0a1020',
    foreground: '#e6ecf7',
    card: '#111a2e',
    cardForeground: '#e6ecf7',
    popover: '#111a2e',
    popoverForeground: '#e6ecf7',
    primary: '#4db8d1',
    primaryForeground: '#04201f',
    secondary: '#18233c',
    secondaryForeground: '#e6ecf7',
    muted: '#18233c',
    mutedForeground: '#93a3bd',
    accent: '#0a3a48',
    accentForeground: '#7dd3e8',
    destructive: '#f87171',
    destructiveForeground: '#1a0606',
    border: 'rgba(255,255,255,0.09)',
    input: 'transparent',
    inputBackground: '#18233c',
    ring: '#4db8d1',
    sidebar: '#00293f',
    sidebarForeground: 'rgba(255,255,255,0.86)',
    sidebarPrimary: '#4db8d1',
    sidebarAccent: 'rgba(255,255,255,0.10)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

// ELPO KURUMSAL PRO (2026-06-19) — color-expert (OKLCH tonal + WCAG kontrast) + frontend-design + OpenDesign
// kurumsal token disipliniyle üretildi. Daha derin lacivert sidebar gradient, daha canlı turkuaz primary,
// color-expert kontrast (foreground AAA), OpenDesign semantic (danger #ef4444). Tema Stüdyosu hazır şablonu.
export const ElpoNavyTurquoisePro: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Elpo Kurumsal Pro',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.7rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#eef3fa',
    foreground: '#0c1a30',
    card: '#ffffff',
    cardForeground: '#0c1a30',
    popover: '#ffffff',
    popoverForeground: '#0c1a30',
    primary: '#0d9488',
    primaryForeground: '#ffffff',
    secondary: '#e3ebf5',
    secondaryForeground: '#0c1a30',
    muted: '#e3ebf5',
    mutedForeground: '#536283',
    accent: '#cfeef0',
    accentForeground: '#08545f',
    destructive: '#ef4444',
    destructiveForeground: '#ffffff',
    border: 'rgba(12,26,48,0.11)',
    input: 'transparent',
    inputBackground: '#e6eef8',
    ring: '#0d9488',
    sidebar: '#0a1730',
    sidebarForeground: 'rgba(233,239,250,0.88)',
    sidebarPrimary: '#34d8c4',
    sidebarAccent: 'rgba(255,255,255,0.07)',
    sidebarBorder: 'rgba(255,255,255,0.09)',
  },
  colorsDark: {
    background: '#070e1d',
    foreground: '#e9eff9',
    card: '#0f1a2e',
    cardForeground: '#e9eff9',
    popover: '#0f1a2e',
    popoverForeground: '#e9eff9',
    primary: '#2dd4bf',
    primaryForeground: '#04201f',
    secondary: '#16223a',
    secondaryForeground: '#e9eff9',
    muted: '#16223a',
    mutedForeground: '#8fa0bd',
    accent: '#0c3b44',
    accentForeground: '#5eead4',
    destructive: '#f87171',
    destructiveForeground: '#1a0606',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: '#16223a',
    ring: '#2dd4bf',
    sidebar: '#060c18',
    sidebarForeground: 'rgba(233,239,250,0.88)',
    sidebarPrimary: '#34d8c4',
    sidebarAccent: 'rgba(255,255,255,0.08)',
    sidebarBorder: 'rgba(255,255,255,0.07)',
  },
};

// ELPO Klasik görünüm — eski portal hissi (köşeli, yoğun, klasik mavi + koyu gri sidebar).
// skin:'classic' → body.skin-classic; aynı hesap/özellik, yalnız görünüm. KAYNAK: elpo-classic-layout.css değerleri.
export const ElpoClassic: ThemeMetadata = {
  ...ElpoDefault,
  name: 'ELPO Klasik',
  skin: 'classic',
  radius: '3px',
  density: 'compact',
  colors: {
    ...ElpoDefault.colors,
    background: '#f1f4f5',
    foreground: '#37474f',
    card: '#ffffff',
    cardForeground: '#37474f',
    popover: '#ffffff',
    popoverForeground: '#37474f',
    primary: '#3e8ef7',
    primaryForeground: '#ffffff',
    secondary: '#f3f7f9',
    secondaryForeground: '#37474f',
    muted: '#f3f7f9',
    mutedForeground: '#76838f',
    accent: '#e8f1fe',
    accentForeground: '#3e8ef7',
    destructive: '#ff4c52',
    destructiveForeground: '#ffffff',
    border: '#e4eaec',
    input: '#ffffff',
    inputBackground: '#ffffff',
    ring: '#3e8ef7',
    sidebar: '#37474f',
    sidebarForeground: 'rgba(255,255,255,0.85)',
    sidebarPrimary: '#3e8ef7',
    sidebarAccent: 'rgba(255,255,255,0.10)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const DarkPro: ThemeMetadata = {
  ...ElpoDefault,
  name: 'Dark Pro',
  colors: ElpoDefault.colorsDark,
  colorsDark: {
    ...ElpoDefault.colorsDark,
    background: '#000000',
    card: '#0f0f0f',
    sidebar: '#000000',
    sidebarBorder: '#1f1f1f',
    primary: '#ffffff',
    primaryForeground: '#000000',
  },
  radius: '0.375rem',
};

export const Ocean: ThemeMetadata = {
  ...ElpoDefault,
  name: 'Ocean',
  colors: {
    ...ElpoDefault.colors,
    primary: '#0369a1',
    primaryForeground: '#ffffff',
    accent: '#e0f2fe',
    accentForeground: '#0c4a6e',
    sidebar: '#f0f9ff',
    sidebarBorder: '#bae6fd',
    sidebarPrimary: '#0369a1',
    sidebarAccent: '#e0f2fe',
    ring: '#0284c7',
  },
  colorsDark: {
    ...ElpoDefault.colorsDark,
    primary: '#38bdf8',
    primaryForeground: '#0c4a6e',
    sidebar: '#082f49',
    sidebarAccent: '#0c4a6e',
    sidebarBorder: '#0c4a6e',
    sidebarPrimary: '#38bdf8',
  },
};

export const Sunset: ThemeMetadata = {
  ...ElpoDefault,
  name: 'Sunset',
  colors: {
    ...ElpoDefault.colors,
    primary: '#ea580c',
    primaryForeground: '#ffffff',
    accent: '#fff7ed',
    accentForeground: '#9a3412',
    sidebar: '#fff7ed',
    sidebarBorder: '#fed7aa',
    sidebarPrimary: '#ea580c',
    sidebarAccent: '#ffedd5',
    ring: '#f97316',
  },
  colorsDark: {
    ...ElpoDefault.colorsDark,
    primary: '#fb923c',
    primaryForeground: '#431407',
    sidebar: '#1c1917',
    sidebarAccent: '#292524',
    sidebarBorder: '#44403c',
    sidebarPrimary: '#fb923c',
  },
};

export const Minimal: ThemeMetadata = {
  ...ElpoDefault,
  name: 'Minimal',
  radius: '0.25rem',
  colors: {
    ...ElpoDefault.colors,
    background: '#fafafa',
    card: '#ffffff',
    primary: '#18181b',
    primaryForeground: '#ffffff',
    border: '#e4e4e7',
    sidebar: '#ffffff',
    sidebarBorder: '#f1f1f5',
    sidebarAccent: '#fafafa',
    sidebarPrimary: '#18181b',
  },
  colorsDark: ElpoDefault.colorsDark,
};


export const MidnightBlue: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Gece Mavisi',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#1e293b',
    foreground: '#ffffff',
    card: '#0f172a',
    cardForeground: '#ffffff',
    popover: '#0f172a',
    popoverForeground: '#ffffff',
    primary: '#38bdf8',
    primaryForeground: '#0f172a',
    secondary: '#1e293b',
    secondaryForeground: '#ffffff',
    muted: '#1e293b',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#1e293b',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#38bdf8',
    sidebar: '#0f172a',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#38bdf8',
    sidebarAccent: 'rgba(56,189,248,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const Carbon: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Karbon',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#27272a',
    foreground: '#ffffff',
    card: '#18181b',
    cardForeground: '#ffffff',
    popover: '#18181b',
    popoverForeground: '#ffffff',
    primary: '#a1a1aa',
    primaryForeground: '#18181b',
    secondary: '#27272a',
    secondaryForeground: '#ffffff',
    muted: '#27272a',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#27272a',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#a1a1aa',
    sidebar: '#18181b',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#a1a1aa',
    sidebarAccent: 'rgba(255,255,255,0.12)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const OceanTeal: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Okyanus',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#064e3b',
    foreground: '#ffffff',
    card: '#042f2e',
    cardForeground: '#ffffff',
    popover: '#042f2e',
    popoverForeground: '#ffffff',
    primary: '#34d399',
    primaryForeground: '#042f2e',
    secondary: '#064e3b',
    secondaryForeground: '#ffffff',
    muted: '#064e3b',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#064e3b',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#34d399',
    sidebar: '#042f2e',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#34d399',
    sidebarAccent: 'rgba(52,211,153,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const RoseWine: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Şarap',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#4a1942',
    foreground: '#ffffff',
    card: '#2a0a1e',
    cardForeground: '#ffffff',
    popover: '#2a0a1e',
    popoverForeground: '#ffffff',
    primary: '#f472b6',
    primaryForeground: '#2a0a1e',
    secondary: '#4a1942',
    secondaryForeground: '#ffffff',
    muted: '#4a1942',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#4a1942',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#f472b6',
    sidebar: '#2a0a1e',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#f472b6',
    sidebarAccent: 'rgba(244,114,182,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const RoyalGold: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Altın Saray',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#2d1b00',
    foreground: '#ffffff',
    card: '#1a1000',
    cardForeground: '#ffffff',
    popover: '#1a1000',
    popoverForeground: '#ffffff',
    primary: '#fbbf24',
    primaryForeground: '#1a1000',
    secondary: '#3d2400',
    secondaryForeground: '#ffffff',
    muted: '#2d1b00',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#3d2400',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#fbbf24',
    sidebar: '#1a1000',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#fbbf24',
    sidebarAccent: 'rgba(251,191,36,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const ElectricCyan: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Elektrik',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#002e4a',
    foreground: '#ffffff',
    card: '#001a2c',
    cardForeground: '#ffffff',
    popover: '#001a2c',
    popoverForeground: '#ffffff',
    primary: '#22d3ee',
    primaryForeground: '#001a2c',
    secondary: '#002e4a',
    secondaryForeground: '#ffffff',
    muted: '#002e4a',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#002e4a',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#22d3ee',
    sidebar: '#001a2c',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#22d3ee',
    sidebarAccent: 'rgba(34,211,238,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const NeonGreen: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Neon Yeşil',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#003300',
    foreground: '#ffffff',
    card: '#001a00',
    cardForeground: '#ffffff',
    popover: '#001a00',
    popoverForeground: '#ffffff',
    primary: '#4ade80',
    primaryForeground: '#001a00',
    secondary: '#003300',
    secondaryForeground: '#ffffff',
    muted: '#003300',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#003300',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#4ade80',
    sidebar: '#001a00',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#4ade80',
    sidebarAccent: 'rgba(74,222,128,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const CrimsonNight: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Kan Kırmızı',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#3b0000',
    foreground: '#ffffff',
    card: '#1a0000',
    cardForeground: '#ffffff',
    popover: '#1a0000',
    popoverForeground: '#ffffff',
    primary: '#f87171',
    primaryForeground: '#1a0000',
    secondary: '#3b0000',
    secondaryForeground: '#ffffff',
    muted: '#3b0000',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#3b0000',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#f87171',
    sidebar: '#1a0000',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#f87171',
    sidebarAccent: 'rgba(248,113,113,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};


export const SunsetOrange: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Gün Batımı',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#3d1c00',
    foreground: '#ffffff',
    card: '#1a0a00',
    cardForeground: '#ffffff',
    popover: '#1a0a00',
    popoverForeground: '#ffffff',
    primary: '#fb923c',
    primaryForeground: '#1a0a00',
    secondary: '#4a2200',
    secondaryForeground: '#ffffff',
    muted: '#3d1c00',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#4a2200',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#fb923c',
    sidebar: '#1a0a00',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#fb923c',
    sidebarAccent: 'rgba(251,146,60,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const NorthernLights: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Kuzey Işıkları',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#0d1b2a',
    foreground: '#ffffff',
    card: '#001520',
    cardForeground: '#ffffff',
    popover: '#001520',
    popoverForeground: '#ffffff',
    primary: '#4db8d1',
    primaryForeground: '#001520',
    secondary: '#1b2838',
    secondaryForeground: '#ffffff',
    muted: '#0d1b2a',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#1b2838',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#4db8d1',
    sidebar: '#001520',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#4db8d1',
    sidebarAccent: 'rgba(0,145,179,0.22)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const ForestNight: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Gece Ormanı',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#1a2e1a',
    foreground: '#ffffff',
    card: '#0a1a0a',
    cardForeground: '#ffffff',
    popover: '#0a1a0a',
    popoverForeground: '#ffffff',
    primary: '#86efac',
    primaryForeground: '#0a1a0a',
    secondary: '#1a2e1a',
    secondaryForeground: '#ffffff',
    muted: '#1a2e1a',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#1a2e1a',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#86efac',
    sidebar: '#0a1a0a',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#86efac',
    sidebarAccent: 'rgba(134,239,172,0.12)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const DarkChocolate: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Çikolata',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#2c1e18',
    foreground: '#ffffff',
    card: '#1c1210',
    cardForeground: '#ffffff',
    popover: '#1c1210',
    popoverForeground: '#ffffff',
    primary: '#d4a574',
    primaryForeground: '#1c1210',
    secondary: '#2c1e18',
    secondaryForeground: '#ffffff',
    muted: '#2c1e18',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#2c1e18',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#d4a574',
    sidebar: '#1c1210',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#d4a574',
    sidebarAccent: 'rgba(212,165,116,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const Obsidian: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Obsidyen',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#141414',
    foreground: '#ffffff',
    card: '#0a0a0a',
    cardForeground: '#ffffff',
    popover: '#0a0a0a',
    popoverForeground: '#ffffff',
    primary: '#e2e8f0',
    primaryForeground: '#0a0a0a',
    secondary: '#141414',
    secondaryForeground: '#ffffff',
    muted: '#141414',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#141414',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#e2e8f0',
    sidebar: '#0a0a0a',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#e2e8f0',
    sidebarAccent: 'rgba(255,255,255,0.1)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const Sapphire: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Safir',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#001d52',
    foreground: '#ffffff',
    card: '#00102e',
    cardForeground: '#ffffff',
    popover: '#00102e',
    popoverForeground: '#ffffff',
    primary: '#60a5fa',
    primaryForeground: '#00102e',
    secondary: '#001d52',
    secondaryForeground: '#ffffff',
    muted: '#001d52',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#001d52',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#60a5fa',
    sidebar: '#00102e',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#60a5fa',
    sidebarAccent: 'rgba(96,165,250,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};


export const SlateStorm: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Fırtına',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#2a3040',
    foreground: '#ffffff',
    card: '#1e2330',
    cardForeground: '#ffffff',
    popover: '#1e2330',
    popoverForeground: '#ffffff',
    primary: '#94a3b8',
    primaryForeground: '#1e2330',
    secondary: '#2a3040',
    secondaryForeground: '#ffffff',
    muted: '#2a3040',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#2a3040',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#94a3b8',
    sidebar: '#1e2330',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#94a3b8',
    sidebarAccent: 'rgba(148,163,184,0.12)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const MatrixGreen: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Matrix',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#001500',
    foreground: '#ffffff',
    card: '#000a00',
    cardForeground: '#ffffff',
    popover: '#000a00',
    popoverForeground: '#ffffff',
    primary: '#00ff41',
    primaryForeground: '#000a00',
    secondary: '#001500',
    secondaryForeground: '#ffffff',
    muted: '#001500',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#001500',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#00ff41',
    sidebar: '#000a00',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#00ff41',
    sidebarAccent: 'rgba(0,255,65,0.12)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const CherryBlossom: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Sakura',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#2d001f',
    foreground: '#ffffff',
    card: '#1a0012',
    cardForeground: '#ffffff',
    popover: '#1a0012',
    popoverForeground: '#ffffff',
    primary: '#fb7185',
    primaryForeground: '#1a0012',
    secondary: '#2d001f',
    secondaryForeground: '#ffffff',
    muted: '#2d001f',
    mutedForeground: 'rgba(255,255,255,0.5)',
    accent: '#2d001f',
    accentForeground: '#ffffff',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    input: 'transparent',
    inputBackground: 'rgba(255,255,255,0.08)',
    ring: '#fb7185',
    sidebar: '#1a0012',
    sidebarForeground: '#ffffff',
    sidebarPrimary: '#fb7185',
    sidebarAccent: 'rgba(251,113,133,0.15)',
    sidebarBorder: 'rgba(255,255,255,0.08)',
  },
};

export const LightClean: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Açık Tema',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#ffffff',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#0091b3',
    primaryForeground: '#ffffff',
    secondary: '#f1f5f9',
    secondaryForeground: '#1e293b',
    muted: '#f1f5f9',
    mutedForeground: '#94a3b8',
    accent: '#f1f5f9',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#e2e8f0',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#0091b3',
    sidebar: '#f8fafc',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#0091b3',
    sidebarAccent: 'rgba(0,145,179,0.1)',
    sidebarBorder: '#e2e8f0',
  },
};

export const LightBlue: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Buz Mavisi',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f0f9ff',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#0284c7',
    primaryForeground: '#ffffff',
    secondary: '#e0f2fe',
    secondaryForeground: '#1e293b',
    muted: '#e0f2fe',
    mutedForeground: '#94a3b8',
    accent: '#e0f2fe',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#bae6fd',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#0284c7',
    sidebar: '#e0f2fe',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#0284c7',
    sidebarAccent: 'rgba(2,132,199,0.1)',
    sidebarBorder: '#bae6fd',
  },
};

export const LightEmerald: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Zümrüt',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#ecfdf5',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#059669',
    primaryForeground: '#ffffff',
    secondary: '#d1fae5',
    secondaryForeground: '#1e293b',
    muted: '#d1fae5',
    mutedForeground: '#94a3b8',
    accent: '#d1fae5',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#a7f3d0',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#059669',
    sidebar: '#d1fae5',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#059669',
    sidebarAccent: 'rgba(5,150,105,0.1)',
    sidebarBorder: '#a7f3d0',
  },
};

export const LightAmber: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Bal',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#fffbeb',
    foreground: '#78350f',
    card: '#ffffff',
    cardForeground: '#78350f',
    popover: '#ffffff',
    popoverForeground: '#78350f',
    primary: '#d97706',
    primaryForeground: '#ffffff',
    secondary: '#fef3c7',
    secondaryForeground: '#78350f',
    muted: '#fef3c7',
    mutedForeground: '#a16207',
    accent: '#fef3c7',
    accentForeground: '#78350f',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#fde68a',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#d97706',
    sidebar: '#fef3c7',
    sidebarForeground: '#78350f',
    sidebarPrimary: '#d97706',
    sidebarAccent: 'rgba(217,119,6,0.1)',
    sidebarBorder: '#fde68a',
  },
};

export const LightRose: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Pembe Şeftali',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#fff1f2',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#e11d48',
    primaryForeground: '#ffffff',
    secondary: '#ffe4e6',
    secondaryForeground: '#1e293b',
    muted: '#ffe4e6',
    mutedForeground: '#94a3b8',
    accent: '#ffe4e6',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#fecdd3',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#e11d48',
    sidebar: '#ffe4e6',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#e11d48',
    sidebarAccent: 'rgba(225,29,72,0.1)',
    sidebarBorder: '#fecdd3',
  },
};


export const LightOrange: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Turuncu',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#fff7ed',
    foreground: '#7c2d12',
    card: '#ffffff',
    cardForeground: '#7c2d12',
    popover: '#ffffff',
    popoverForeground: '#7c2d12',
    primary: '#ea580c',
    primaryForeground: '#ffffff',
    secondary: '#ffedd5',
    secondaryForeground: '#7c2d12',
    muted: '#ffedd5',
    mutedForeground: '#c2410c',
    accent: '#ffedd5',
    accentForeground: '#7c2d12',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#fed7aa',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#ea580c',
    sidebar: '#ffedd5',
    sidebarForeground: '#7c2d12',
    sidebarPrimary: '#ea580c',
    sidebarAccent: 'rgba(234,88,12,0.1)',
    sidebarBorder: '#fed7aa',
  },
};

export const LightCyan: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Turkuaz',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#ecfeff',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#0891b2',
    primaryForeground: '#ffffff',
    secondary: '#cffafe',
    secondaryForeground: '#1e293b',
    muted: '#cffafe',
    mutedForeground: '#94a3b8',
    accent: '#cffafe',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#a5f3fc',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#0891b2',
    sidebar: '#cffafe',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#0891b2',
    sidebarAccent: 'rgba(8,145,178,0.1)',
    sidebarBorder: '#a5f3fc',
  },
};

export const LightLime: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Fıstık Yeşili',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f7fee7',
    foreground: '#365314',
    card: '#ffffff',
    cardForeground: '#365314',
    popover: '#ffffff',
    popoverForeground: '#365314',
    primary: '#65a30d',
    primaryForeground: '#ffffff',
    secondary: '#ecfccb',
    secondaryForeground: '#365314',
    muted: '#ecfccb',
    mutedForeground: '#4d7c0f',
    accent: '#ecfccb',
    accentForeground: '#365314',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#d9f99d',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#65a30d',
    sidebar: '#ecfccb',
    sidebarForeground: '#365314',
    sidebarPrimary: '#65a30d',
    sidebarAccent: 'rgba(101,163,13,0.1)',
    sidebarBorder: '#d9f99d',
  },
};

export const LightSlate: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Gümüş',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f8fafc',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#475569',
    primaryForeground: '#ffffff',
    secondary: '#e2e8f0',
    secondaryForeground: '#1e293b',
    muted: '#e2e8f0',
    mutedForeground: '#94a3b8',
    accent: '#e2e8f0',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#cbd5e1',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#475569',
    sidebar: '#e2e8f0',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#475569',
    sidebarAccent: 'rgba(71,85,105,0.1)',
    sidebarBorder: '#cbd5e1',
  },
};


export const LightCoral: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Mercan',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#fef2f2',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#dc2626',
    primaryForeground: '#ffffff',
    secondary: '#fecaca',
    secondaryForeground: '#1e293b',
    muted: '#fecaca',
    mutedForeground: '#94a3b8',
    accent: '#fecaca',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#fca5a5',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#dc2626',
    sidebar: '#fecaca',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#dc2626',
    sidebarAccent: 'rgba(220,38,38,0.1)',
    sidebarBorder: '#fca5a5',
  },
};

export const LightSky: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Gökyüzü',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#f0f9ff',
    foreground: '#1e293b',
    card: '#ffffff',
    cardForeground: '#1e293b',
    popover: '#ffffff',
    popoverForeground: '#1e293b',
    primary: '#0369a1',
    primaryForeground: '#ffffff',
    secondary: '#e0f2fe',
    secondaryForeground: '#1e293b',
    muted: '#e0f2fe',
    mutedForeground: '#94a3b8',
    accent: '#e0f2fe',
    accentForeground: '#1e293b',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#7dd3fc',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#0369a1',
    sidebar: '#e0f2fe',
    sidebarForeground: '#1e293b',
    sidebarPrimary: '#0369a1',
    sidebarAccent: 'rgba(3,105,161,0.1)',
    sidebarBorder: '#7dd3fc',
  },
};

export const LightWarm: ThemeMetadata = {
  schemaVersion: 1,
  name: 'Kum Beji',
  font: { family: 'Inter', baseSize: '14px' },
  radius: '0.625rem',
  density: 'comfortable',
  sidebar: { width: 240, collapsedWidth: 68 },
  colors: {
    background: '#fefce8',
    foreground: '#713f12',
    card: '#ffffff',
    cardForeground: '#713f12',
    popover: '#ffffff',
    popoverForeground: '#713f12',
    primary: '#a16207',
    primaryForeground: '#ffffff',
    secondary: '#fef9c3',
    secondaryForeground: '#713f12',
    muted: '#fef9c3',
    mutedForeground: '#a16207',
    accent: '#fef9c3',
    accentForeground: '#713f12',
    destructive: '#d4183d',
    destructiveForeground: '#ffffff',
    border: '#fef08a',
    input: 'transparent',
    inputBackground: '#f8fafc',
    ring: '#a16207',
    sidebar: '#fef9c3',
    sidebarForeground: '#713f12',
    sidebarPrimary: '#a16207',
    sidebarAccent: 'rgba(161,98,7,0.1)',
    sidebarBorder: '#fef08a',
  },
};

// ── 12 küratörlü palet (2026-06) ──────────────────────────────────────────
// Mantık: CHROME (menü+header) markanın "wow" rengini taşır; İÇERİK (form/sayfa)
// her zaman sakin + okunaklı kalır — sadece accent (buton/link/odak) palete göre değişir.
// Her palet HEM koyu HEM açık içerir; ikon/aktif rengi menü zeminine göre okunaklılaştırılır.

function paletteLum(hex: string): number {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex.trim());
  if (!m) return 0.5;
  return (0.299 * parseInt(m[1]!, 16) + 0.587 * parseInt(m[2]!, 16) + 0.114 * parseInt(m[3]!, 16)) / 255;
}

// Rengin tonunu koruyup menü zeminine göre okunaklı yapar (koyu zemin→aç, açık→koyu).
function paletteLegible(hex: string, onDark: boolean): string {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex.trim());
  if (!m) return hex;
  let r = parseInt(m[1]!, 16), g = parseInt(m[2]!, 16), b = parseInt(m[3]!, 16);
  const l = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  if (onDark && l < 0.62) { const k = (0.62 - l) / (1 - l); r = Math.round(r + (255 - r) * k); g = Math.round(g + (255 - g) * k); b = Math.round(b + (255 - b) * k); }
  else if (!onDark && l > 0.42) { const k = (l - 0.42) / l; r = Math.round(r * (1 - k)); g = Math.round(g * (1 - k)); b = Math.round(b * (1 - k)); }
  const h = (n: number) => n.toString(16).padStart(2, '0');
  return `#${h(r)}${h(g)}${h(b)}`;
}

interface PaletteSpec { name: string; aL: string; aD: string; sL: string; sLf: string; sD: string; sDf: string; }

function makePalette(s: PaletteSpec): ThemeMetadata {
  const sideColors = (acc: string, side: string, sideFg: string) => {
    const chromeDark = paletteLum(side) < 0.55;
    return {
      sidebar: side,
      sidebarForeground: sideFg,
      sidebarPrimary: paletteLegible(acc, chromeDark),
      sidebarAccent: chromeDark ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.05)',
      sidebarBorder: chromeDark ? 'rgba(255,255,255,0.09)' : 'rgba(0,0,0,0.08)',
    };
  };
  const primaryFg = (acc: string) => (paletteLum(acc) > 0.6 ? '#0a0b14' : '#ffffff');
  return {
    schemaVersion: 1,
    name: s.name,
    font: { family: 'Inter', baseSize: '14px' },
    radius: '0.625rem',
    density: 'comfortable',
    sidebar: { width: 240, collapsedWidth: 68 },
    // AÇIK içerik — sakin/okunaklı; accent = paletin açık tonu
    colors: {
      background: '#f4f5fb', foreground: '#14172a',
      card: '#ffffff', cardForeground: '#14172a',
      popover: '#ffffff', popoverForeground: '#14172a',
      primary: s.aL, primaryForeground: primaryFg(s.aL),
      secondary: '#eef0f6', secondaryForeground: '#14172a',
      muted: '#eef0f6', mutedForeground: '#6b7180',
      accent: '#eef0f6', accentForeground: s.aL,
      destructive: '#dc2626', destructiveForeground: '#ffffff',
      border: 'rgba(20,23,42,0.11)', input: 'transparent', inputBackground: '#eef0f6',
      ring: s.aL,
      ...sideColors(s.aL, s.sL, s.sLf),
    },
    // KOYU içerik
    colorsDark: {
      background: '#0a0b14', foreground: '#e7e9f3',
      card: '#14151f', cardForeground: '#e7e9f3',
      popover: '#14151f', popoverForeground: '#e7e9f3',
      primary: s.aD, primaryForeground: primaryFg(s.aD),
      secondary: '#1a1c28', secondaryForeground: '#e7e9f3',
      muted: '#1a1c28', mutedForeground: '#9aa0b4',
      accent: '#1a1c28', accentForeground: s.aD,
      destructive: '#f87171', destructiveForeground: '#1a0606',
      border: 'rgba(255,255,255,0.09)', input: 'transparent', inputBackground: '#1a1c28',
      ring: s.aD,
      ...sideColors(s.aD, s.sD, s.sDf),
    },
  };
}

export const EmeraldFinance = makePalette({ name: 'Zümrüt Finans', aL: '#059669', aD: '#34d399', sL: '#052e23', sLf: '#d1fae5', sD: '#04130f', sDf: '#d1fae5' });
export const OceanBlue = makePalette({ name: 'Okyanus Mavi', aL: '#0284c7', aD: '#38bdf8', sL: '#0c2f44', sLf: '#d8eefb', sD: '#071a26', sDf: '#d8eefb' });
export const GraphiteMono = makePalette({ name: 'Grafit Mono', aL: '#475569', aD: '#94a3b8', sL: '#ffffff', sLf: '#1e293b', sD: '#0b1120', sDf: '#cbd5e1' });
export const SunsetGlow = makePalette({ name: 'Gün Batımı', aL: '#ea580c', aD: '#fb923c', sL: '#431407', sLf: '#fde4d3', sD: '#1c1917', sDf: '#fde4d3' });
export const RoseMagenta = makePalette({ name: 'Gül / Magenta', aL: '#db2777', aD: '#f472b6', sL: '#500724', sLf: '#fbd9e8', sD: '#2a0414', sDf: '#fbd9e8' });
export const TealCyan = makePalette({ name: 'Teal Camgöbeği', aL: '#0d9488', aD: '#2dd4bf', sL: '#042f2e', sLf: '#ccfbf1', sD: '#021716', sDf: '#ccfbf1' });
export const Bordeaux = makePalette({ name: 'Bordo', aL: '#dc2626', aD: '#f87171', sL: '#450a0a', sLf: '#fbd5d5', sD: '#260606', sDf: '#fbd5d5' });
export const ForestGreen = makePalette({ name: 'Orman Yeşili', aL: '#16a34a', aD: '#4ade80', sL: '#052e16', sLf: '#d6f5e0', sD: '#03160b', sDf: '#d6f5e0' });
export const BronzeGold = makePalette({ name: 'Bronz / Altın', aL: '#b45309', aD: '#fbbf24', sL: '#3a2410', sLf: '#f5e6cf', sD: '#1f130a', sDf: '#f5e6cf' });
export const MidnightNavy = makePalette({ name: 'Gece Lacivert', aL: '#2563eb', aD: '#60a5fa', sL: '#0b1437', sLf: '#d6e0fb', sD: '#070d22', sDf: '#d6e0fb' });

export const THEME_PRESETS: readonly { key: string; theme: ThemeMetadata; category: 'default' | 'dark' | 'light' }[] = [
  { key: 'elpo-corporate', theme: ElpoNavyTurquoise, category: 'default' },
  { key: 'elpo-corporate-pro', theme: ElpoNavyTurquoisePro, category: 'default' },
  { key: 'emerald-finance', theme: EmeraldFinance, category: 'default' },
  { key: 'ocean-blue', theme: OceanBlue, category: 'default' },
  { key: 'graphite-mono', theme: GraphiteMono, category: 'default' },
  { key: 'sunset-glow', theme: SunsetGlow, category: 'default' },
  { key: 'rose-magenta', theme: RoseMagenta, category: 'default' },
  { key: 'teal-cyan', theme: TealCyan, category: 'default' },
  { key: 'bordeaux', theme: Bordeaux, category: 'default' },
  { key: 'forest-green', theme: ForestGreen, category: 'default' },
  { key: 'bronze-gold', theme: BronzeGold, category: 'default' },
  { key: 'midnight-navy', theme: MidnightNavy, category: 'default' },
];
